import { clone, isEmpty, isNil } from "ramda";
import { putAsset, putConfigData, putEquipment } from "../../../api";
import { getAssetsDataAction } from "../../../redux/assetsSlice";
import { toast } from "react-toastify";
import { getConfigDataSuccess } from "../../../redux/configSlice";
import * as turf from "@turf/turf";
import worldLand from "../../../../config/georef-spain-provincia.json";
export const onRemoveHandler = ({
  measureIndex,
  channelIndex,
  zoneIndex,
  index2,
  tuples,
  setTuples,
  tuplesActive,
  setTuplesActive,
}) => {
  let localTuples = clone(tuples);
  localTuples[measureIndex][channelIndex][zoneIndex][index2] = 0;
  setTuples(localTuples);
  let localActive = clone(tuplesActive);
  localActive[measureIndex][channelIndex][zoneIndex][index2] = 0;
  setTuplesActive(localActive);
};

export const onValueChangeHandler = ({
  value,
  measureIndex,
  channelIndex,
  zoneIndex,
  index2,
  tuples,
  setTuples,
  tuplesActive,
  setTuplesActive,
}) => {
  if (!isNil(value)) {
    const localTuples = clone(tuples);

    const modifiedTuple = [...localTuples[measureIndex][channelIndex][zoneIndex]];
    modifiedTuple[index2] = value;
    localTuples[measureIndex][channelIndex][zoneIndex] = modifiedTuple;
    setTuples(localTuples);
  }
};

export const onBlurHandler = ({
  idErrorPrefix,
  measureIndex,
  channelIndex,
  zoneIndex,
  tuples,
  errors,
  setErrors,
  setTuples,
  tuplesActive,
  setTuplesActive,
  intl,
}) => {
  const newErrors = { ...errors };
  const localTuples = [...tuples];

  for (let j = localTuples[measureIndex][channelIndex][zoneIndex].length - 1; j >= 0; j--) {
    let isGreater = true;

    for (let k = 0; k < j; k++) {
      const active1 = tuplesActive[measureIndex][channelIndex][zoneIndex][j];
      const active2 = tuplesActive[measureIndex][channelIndex][zoneIndex][k];
      if (active1 === 1 && active2 === 1) {
        if (
          localTuples[measureIndex][channelIndex][zoneIndex][j] <= localTuples[measureIndex][channelIndex][zoneIndex][k]
        ) {
          isGreater = false;
          break;
        }
      }
    }

    if (!isGreater) {
      newErrors[`${idErrorPrefix}-${j}`] = `greater.previous`;
    } else {
      delete newErrors[`${idErrorPrefix}-${j}`];
    }
  }

  setTuples(localTuples);
  setErrors(newErrors);
};

export const updateData = async ({
  selectedAsset,
  selectedEquipment,
  equipments,
  setLoading,
  dispatch,
  assets,
  role,
  currentUser,
  intl,
}) => {
  setLoading(true);
  const data = {
    id: selectedAsset.id,
    name: selectedAsset.name,
    zoom: selectedAsset.zoom,
    centroid: selectedAsset.centroid,
    image: selectedAsset.image,
    dateTime: selectedAsset.dateTime,
    demarcation: selectedAsset.demarcation,
    timezone: selectedAsset.timezone,
    sensors: selectedAsset.sensors,
    modules: selectedAsset.modules,
  };
  try {
    let result = await putAsset(data, data.id, intl);
    if (result?.status === 200) {
      if (role === "total_admin" || role === "administrator" || role === "operator") {
        const finalEquipments = [];
        result = await putEquipment(selectedEquipment, intl);

        if (result.status !== 200) {
          toast.error(`Error: An equipment was not updated`, { className: "toast-error" });
        } else {
          finalEquipments.push(selectedEquipment);
        }
      }
      const newAssets = [...assets.data];
      const assetIndex = newAssets.findIndex((item) => item.name === selectedAsset.name);
      newAssets[assetIndex] = { ...data, equipments: equipments };
      dispatch(getAssetsDataAction(currentUser.id));
    }
  } catch (error) {
    toast.error(error.message, { className: "toast-error" });
  }
  setLoading(false);
};

export const updateDataReloadTime = async (currentConfig, dataReloadTime, dispatch, setLoading, intl) => {
  setLoading(true);
  let data = clone(currentConfig.data);
  data.loadTime = parseInt(dataReloadTime);
  try {
    const result = await putConfigData(data, currentConfig.data.id, intl);
    if (result.status === 200) {
      const newConfig = { ...currentConfig };
      newConfig.data = data;
      dispatch(getConfigDataSuccess(newConfig.data));
    }
  } catch (error) {
    toast.error(error.message, { className: "toast-error" });
  }
  setLoading(false);
};

export const handleChannels = ({
  e,
  tuples,
  setTuples,
  thresholdsRanges,
  setThresholdsRanges,
  tuplesActive,
  setTuplesActive,
  channelToggle,
  setChannelToggle,
  zoneToggle,
  setZoneToggle,
  selectedEquipment,
  errors,
  setErrors,
}) => {
  const newErrors = { ...errors };
  if (isEmpty(e.target.value)) {
    newErrors[e.target.id] = "not.empty";
  } else {
    delete newErrors[e.target.id];
  }
  setErrors(newErrors);

  let newTuples = clone(tuples);
  let newThresholdRanges = clone(thresholdsRanges);
  let newTuplesActive = clone(tuplesActive);
  let newChannelToggle = clone(channelToggle);
  let newZoneToggle = clone(zoneToggle);

  if (parseInt(e.target.value) > selectedEquipment.channels.length) {
    for (let newChannels = 0; newChannels < parseInt(e.target.value); newChannels++) {
      for (let measureIndex = 0; measureIndex < selectedEquipment.pMeasureNames.length; measureIndex++) {
        if (
          isNil(newTuples[measureIndex][newChannels]) &&
          isNil(newTuplesActive[measureIndex][newChannels]) &&
          isNil(newTuples[measureIndex][newChannels])
        ) {
          newTuples[measureIndex].push([]);
          newTuplesActive[measureIndex].push([]);
          newThresholdRanges[measureIndex].push([]);
        }
        if (isNil(newTuples[measureIndex][newChannels][0])) {
          newTuples[measureIndex][newChannels].push([0]);
          newTuplesActive[measureIndex][newChannels].push([0, 0, 0]);
        }
        if (isNil(newThresholdRanges[measureIndex][newChannels][0])) {
          newThresholdRanges[measureIndex][newChannels].push("0-1");
        }
        if (isNil(newChannelToggle[measureIndex][newChannels])) {
          newChannelToggle[measureIndex].push(false);
        }
        if (isNil(newZoneToggle[measureIndex][newChannels])) {
          newZoneToggle[measureIndex].push([]);
          newZoneToggle[measureIndex][newChannels].push(false);
        }
      }
    }
  } else {
    for (let measureIndex = 0; measureIndex < selectedEquipment.pMeasureNames.length; measureIndex++) {
      newTuples[measureIndex].splice(parseInt(e.target.value));
      newTuplesActive[measureIndex].splice(parseInt(e.target.value));
      newThresholdRanges[measureIndex].splice(parseInt(e.target.value));
      newChannelToggle[measureIndex].splice(parseInt(e.target.value));
      newZoneToggle[measureIndex].splice(parseInt(e.target.value));
    }
  }
  setTuples(newTuples);
  setTuplesActive(newTuplesActive);
  setThresholdsRanges(newThresholdRanges);
  setChannelToggle(newChannelToggle);
  setZoneToggle(newZoneToggle);
};
export const handleZones = ({
  e,
  equipments,
  selectedEquipment,
  channelIndex,
  indexSub,
  zoneToggle,
  errors,
  setErrors,
  polylineDisplay,
  setEquipments,
  setSelectedEquipment,
}) => {
  const newZoneCount = Number(e.target.value);
  const indexEquipment = equipments.findIndex((equipment) => equipment.equipmentID === selectedEquipment.equipmentID);
  const newEquipments = [...equipments];
  const updatedEquipment = { ...newEquipments[indexEquipment] };
  const updatedChannel = { ...updatedEquipment.channels[channelIndex] };
  const updatedSub = { ...updatedChannel.substructures[indexSub] };
  const currentZones = [...updatedSub.zones];

  let newZoneToggle = clone(zoneToggle);
  let newErrors = { ...errors };

  if (newZoneCount > currentZones.length) {
    const lastZone = currentZones[currentZones.length - 1];
    const extraZones = [];

    for (let i = 0; i < newZoneCount - currentZones.length; i++) {
      const previousEnd = i === 0 ? (lastZone ? lastZone.end : 0) : extraZones[i - 1].end;
      extraZones.push({
        ini: previousEnd + 1,
        end: previousEnd + 2,
        alertsConfigurations: null,
      });
    }

    updatedSub.zones = [...currentZones, ...extraZones];
  } else {
    updatedSub.zones = currentZones.slice(0, newZoneCount);
  }

  const updatedSubstructures = [...updatedChannel.substructures];
  updatedSubstructures[indexSub] = updatedSub;

  const updatedChannelFixed = { ...updatedChannel, substructures: updatedSubstructures };

  const updatedChannels = [...updatedEquipment.channels];
  updatedChannels[channelIndex] = updatedChannelFixed;

  updatedEquipment.channels = updatedChannels;
  newEquipments[indexEquipment] = updatedEquipment;

  newZoneToggle[channelIndex][indexSub] = [];
  for (let zoneIndex = 0; zoneIndex < newZoneCount; zoneIndex++) {
    if (!isNil(zoneToggle[channelIndex][indexSub][zoneIndex])) {
      newZoneToggle[channelIndex][indexSub].push(zoneToggle[channelIndex][indexSub][zoneIndex]);
    } else {
      newZoneToggle[channelIndex][indexSub].push(false);
    }
  }

  // Validamos las zonas recién creadas contra los límites reales
  if (newZoneCount > currentZones.length) {
    for (let zoneIndex = currentZones.length; zoneIndex < newZoneCount; zoneIndex++) {
      const zone = updatedSub.zones[zoneIndex];

      const minResult = minHandler({
        e: { target: { value: String(zone.ini) } },
        selectedEquipment: updatedEquipment,
        equipments: newEquipments,
        setSelectedEquipment: () => {}, // evitamos commits intermedios, hacemos uno solo al final
        setEquipments: () => {},
        channelIndex,
        indexSub,
        zoneIndex,
        errors: newErrors,
        setErrors: (updated) => {
          newErrors = updated;
        },
      });

      const maxResult = maxHandler({
        e: { target: { value: String(zone.end) } },
        selectedEquipment: updatedEquipment,
        equipments: newEquipments,
        setSelectedEquipment: () => {},
        setEquipments: () => {},
        polylineDisplay,
        channelIndex,
        indexSub,
        zoneIndex,
        errors: newErrors,
        setErrors: (updated) => {
          newErrors = updated;
        },
      });
    }
  }

  setErrors(newErrors);
  setSelectedEquipment(updatedEquipment);
  setEquipments(newEquipments);
};
export const minHandler = ({
  e,
  equipments,
  setSelectedEquipment,
  setEquipments,
  channelIndex,
  indexSub,
  zoneIndex,
  setErrors,
  setRealState,
}) => {
  const prevId = `equipment_${channelIndex}_${indexSub}_${zoneIndex - 1}_1`;
  const id = `equipment_${channelIndex}_${indexSub}_${zoneIndex}_0`;
  const nextId = `equipment_${channelIndex}_${indexSub}_${zoneIndex}_1`;
  const value = parseFloat(e.target.value);
  console.log("minHandler called, value:", e.target.value);
  setSelectedEquipment((prevSelectedEquipment) => {
    const newSelectedEquipment = { ...prevSelectedEquipment };
    const newChannels = [...newSelectedEquipment.channels];
    const newChannel = { ...newChannels[channelIndex] };
    const newSubstructures = [...newChannel.substructures];
    const newSub = { ...newSubstructures[indexSub] };
    const newZones = newSub.zones.map((zone) => ({ ...zone }));

    const previousZone = newZones[zoneIndex - 1];
    const currentZone = newZones[zoneIndex];

    // Calculamos el error basándonos en el estado MÁS RECIENTE, no en un closure viejo
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (isEmpty(e.target.value)) {
        newErrors[id] = "not.empty";
      } else if (isNil(previousZone)) {
        if (value < currentZone.end) {
          delete newErrors[id];
          delete newErrors[nextId];
        } else {
          newErrors[id] = "min.lower.max";
        }
      } else {
        if (previousZone.end < value && value < currentZone.end) {
          delete newErrors[prevId];
          delete newErrors[id];
          delete newErrors[nextId];
        } else {
          newErrors[id] = "prevMax.thisMax";
        }
      }

      return newErrors;
    });

    newZones[zoneIndex] = { ...currentZone, ini: value };
    newSub.zones = newZones;
    newSubstructures[indexSub] = newSub;
    newChannel.substructures = newSubstructures;
    newChannels[channelIndex] = newChannel;
    newSelectedEquipment.channels = newChannels;
    setRealState(false);
    // Actualizamos equipments también dentro del updater, con datos frescos
    setEquipments((prevEquipments) => {
      const indexEquipment = prevEquipments.findIndex((eq) => eq.equipmentID === newSelectedEquipment.equipmentID);
      const newEquipments = [...prevEquipments];
      newEquipments[indexEquipment] = newSelectedEquipment;
      return newEquipments;
    });

    return newSelectedEquipment;
  });
};

export const maxHandler = ({
  e,
  equipments,
  setSelectedEquipment,
  setEquipments,
  polylineDisplay,
  channelIndex,
  indexSub,
  zoneIndex,
  setRealState,
  setErrors,
}) => {
  const prevId = `equipment_${channelIndex}_${indexSub}_${zoneIndex}_0`;
  const id = `equipment_${channelIndex}_${indexSub}_${zoneIndex}_1`;
  const nextId = `equipment_${channelIndex}_${indexSub}_${zoneIndex + 1}_0`;
  const value = parseFloat(e.target.value);

  setSelectedEquipment((prevSelectedEquipment) => {
    const sub = prevSelectedEquipment.channels[channelIndex].substructures[indexSub];
    const nextZone = prevSelectedEquipment.channels[channelIndex].substructures[indexSub][zoneIndex + 1];
    const currentZone = prevSelectedEquipment.channels[channelIndex].substructures[indexSub].zones[zoneIndex];

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      if (isEmpty(e.target.value)) {
        newErrors[id] = "not.empty";
      }

      if (isNil(nextZone) && value > currentZone.ini) {
        if (newErrors[prevId] !== "prevMax.thisMax") {
          delete newErrors[prevId];
        }
        delete newErrors[id];
      } else if (isNil(nextZone) && value <= currentZone.ini) {
        newErrors[id] = "max.higher.min";
      }

      if (!isNil(nextZone)) {
        if (nextZone.ini > value && value > currentZone.ini) {
          delete newErrors[prevId];
          delete newErrors[id];
          delete newErrors[nextId];
        } else if (nextZone.ini <= value || value <= currentZone.ini) {
          newErrors[id] = "thisMin.nextMin";
        }
      }

      const provName =
        sub.type === "generic"
          ? prevSelectedEquipment.channels[channelIndex].substructures[indexSub].polyline
          : prevSelectedEquipment.channels[channelIndex].substructures[indexSub].depth;

      if (sub.type === "generic") {
        if (value > polylineDisplay[provName].points[polylineDisplay[provName].points.length - 1].pk) {
          newErrors[id] = "higher.than.highest.pk";
        }
      } else {
        if (value > provName) {
          newErrors[id] = "deeper.than.depth.defined";
        }
      }

      return newErrors;
    });

    const newSelectedEquipment = { ...prevSelectedEquipment };
    const newChannels = [...newSelectedEquipment.channels];
    const newChannel = { ...newChannels[channelIndex] };
    const newSubstructures = [...newChannel.substructures];
    const newSub = { ...newSubstructures[indexSub] };
    const newZones = newSub.zones.map((zone) => ({ ...zone }));

    newZones[zoneIndex] = { ...newZones[zoneIndex], end: value };
    newSub.zones = newZones;
    newSubstructures[indexSub] = newSub;
    newChannel.substructures = newSubstructures;
    newChannels[channelIndex] = newChannel;
    newSelectedEquipment.channels = newChannels;
    setRealState(false);

    setEquipments((prevEquipments) => {
      const indexEquipment = prevEquipments.findIndex((eq) => eq.equipmentID === newSelectedEquipment.equipmentID);
      const newEquipments = [...prevEquipments];
      newEquipments[indexEquipment] = newSelectedEquipment;
      return newEquipments;
    });

    return newSelectedEquipment;
  });
};
export const handleActiveThresholds = ({
  event,
  tuples,
  tuplesActive,
  index2,
  measureIndex,
  channelIndex,
  zoneIndex,
  setTuples,
  setTuplesActive,
}) => {
  let newTuplesActive = clone(tuplesActive);
  let newTuples = clone(tuples);
  if (event.target.checked) {
    const whereToAdd = index2;

    const nextTo = newTuplesActive[measureIndex][channelIndex][zoneIndex].lastIndexOf(1);
    let value = null;
    if (whereToAdd > nextTo) {
      const max = Math.max(...newTuples[measureIndex][channelIndex][zoneIndex]);
      value = max + 1;
    } else {
      const filtro = newTuples[measureIndex][channelIndex][zoneIndex][nextTo];
      value = filtro - (nextTo - whereToAdd);
    }
    newTuples[measureIndex][channelIndex][zoneIndex][whereToAdd] = value;

    newTuplesActive[measureIndex][channelIndex][zoneIndex][index2] = 1;
  } else {
    newTuplesActive[measureIndex][channelIndex][zoneIndex][index2] = 0;
  }
  setTuples(newTuples);
  setTuplesActive(newTuplesActive);
};

export const handleAlertConfig = ({
  equipments,
  selectedEquipment,
  channelIndex,
  indexSub,
  zoneIndex,
  values,
  setSelectedEquipment,
  setEquipments,
}) => {
  const indexEquipment = equipments.findIndex((equipment) => equipment.equipmentID === selectedEquipment.equipmentID);

  const newEquipments = [...equipments];

  const updatedEquipment = {
    ...selectedEquipment,
    channels: selectedEquipment.channels.map((channel, cIdx) =>
      cIdx === channelIndex
        ? {
            ...channel,
            substructures: channel.substructures.map((sub, sIdx) =>
              sIdx === indexSub
                ? {
                    ...sub,
                    zones: sub.zones.map((zone, zIdx) =>
                      zIdx === zoneIndex ? { ...zone, alertsConfigurations: values } : zone,
                    ),
                  }
                : sub,
            ),
          }
        : channel,
    ),
  };

  newEquipments[indexEquipment] = updatedEquipment;

  setSelectedEquipment(updatedEquipment);
  setEquipments(newEquipments);
};

export const handleInterMeasurementTime = ({
  equipmentInterMeasurement,
  errors,
  setErrors,
  value,
  actualID,
  equipments,
  selectedEquipmentID,
  selectedEquipment,
  setSelectedEquipment,
  setEquipments,
  setEquipmentInterMeasurement,
}) => {
  const falseStateChannels = selectedEquipment.channels.reduce((indices, valor, indice) => {
    if (!valor.state) {
      indices.push(indice);
    }
    return indices;
  }, []);
  let auxEquipmentInterMeasurement = equipmentInterMeasurement;
  for (let indexState = 0; indexState < falseStateChannels.length; indexState++) {
    if (
      !isNil(selectedEquipment.channels[falseStateChannels[indexState]].measurement) &&
      !isNil(selectedEquipment.channels[falseStateChannels[indexState]].measurement.measurementTime)
    ) {
      auxEquipmentInterMeasurement =
        auxEquipmentInterMeasurement -
        selectedEquipment.channels[falseStateChannels[indexState]].measurement.measurementTime;
    }
  }
  setEquipmentInterMeasurement(auxEquipmentInterMeasurement);
  const newErrors = { ...errors };
  if (isEmpty(value)) {
    newErrors[actualID] = "not.empty";
  } else if (parseFloat(value) < auxEquipmentInterMeasurement) {
    newErrors[actualID] = "not.higher.than.amount.measurement.time.channels";
  } else if (parseFloat(value) > 86400) {
    newErrors[actualID] = "not.higher.than.day";
  } else {
    delete newErrors[actualID];
  }

  setErrors(newErrors);
  if (!isNil(value)) {
    const index = equipments.findIndex((equipment) => equipment.equipmentID === selectedEquipmentID);
    const newEquipments = [...equipments];
    const updatedEquipment = {
      ...newEquipments[index],
      measurementInfo: {
        ...newEquipments[index].measurementInfo,
        interval: parseFloat(value),
      },
    };
    newEquipments[index] = updatedEquipment;
    setSelectedEquipment(updatedEquipment);
    setEquipments(newEquipments);
  }
};

export async function offsetPolygonPerSegment(polyline, distance1, distance2, intl) {
  const points = polyline.points
    .map((line, lineIndex) => (polyline.must_graph_points.includes(lineIndex) ? [line.latitude, line.longitude] : null))
    .filter(Boolean);
  const newPoints = [];
  for (let index = 0; index < points.length; index++) {
    const point = [points[index][1], points[index][0]];
    let isOnLand = false;
    for (const feature of worldLand.features) {
      if (turf.booleanPointInPolygon(point, feature)) {
        isOnLand = true;
        break;
      }
    }
    if (!isOnLand) {
      newPoints.push([points[index][0], points[index][1]]);
    }
  }
  if (!isEmpty(newPoints)) {
    // Convertir a línea GeoJSON
    const line = turf.lineString(newPoints);

    // Buffers en metros
    const criticalBuffer = turf.buffer(line, distance1 / 1000, { units: "kilometers" });
    const protectBuffer = turf.buffer(line, distance2 / 1000, {
      units: "kilometers",
    });

    // Convertir a formato Leaflet (lat, lng)
    const criticalCoords = criticalBuffer.geometry.coordinates[0];
    const protectCoords = protectBuffer.geometry.coordinates[0];

    return { criticalCoords: criticalCoords, protectCoords: protectCoords };
  }
}
